<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>
                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-lg">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                Unit 4 Sync Status
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-indigo-300">
                                                When the status is off, it means the queue is open and not automatically syncing to Unit 4.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="pt-6 pb-5">
                                                <div>
                                                    <label for="first_name"
                                                           class="block text-sm text-gray-900">
                                                        Status
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="status" name="status" v-model="form.status" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-light-pitch-purple sm:text-sm rounded-md">
                                                            <option value="on">On</option>
                                                            <option value="off">Off</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button type="submit"
                                            :disabled="isProcessing"
                                            class="ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="!isProcessing">Save</span>
                                        <span v-else>Processing...</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive} from 'vue'
import {useForm, usePage} from '@inertiajs/vue3'
import { router } from '@inertiajs/vue3'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'


export default {
    components: {
        XIcon,
        Dialog,
        LinkIcon,
        PlusSmIcon,
        DialogTitle,
        DialogOverlay,
        TransitionRoot,
        TransitionChild,
        ExclamationCircleIcon,
    },
    setup(prop, context) {
        const isProcessing = ref(false);

        const show = ref(false)

        const unit_4_queue_open = usePage().props.unit_4_queue_open

        const form = useForm({
            status: unit_4_queue_open ? 'off' : 'on'
        })

        function submit() {
            isProcessing.value = true;

            this.form.post(route('unit-4-settings.update_sync_queue'), {
                onSuccess: page => {
                    window.location.reload();
                },
                onFinish: () => {
                    isProcessing.value = false;
                },
                onError: errors => {
                    console.error(errors);
                }
            });
        }

        function close() {
            this.show = false;
            this.form.reset();
        }

        function open() {
            this.show = true;
        }

        return {
            show,
            form,
            submit,
            close,
            open,
            unit_4_queue_open
        }
    },
}
</script>
